export const modal = {
  fontFamily: 'Poppins, sans-serif',
  position: 'absolute' as 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  outline: 'none',
  width: '40%',
  bgcolor: 'var(--bg-elevated)',
  borderRadius: '12px',
  padding: '24px 20px 20px 20px',
  maxHeight: '90%',
  '&::-webkit-scrollbar': {
    width: '5px',
  },
  '&::-webkit-scrollbar-track': {
    backgroundColor: 'transparent',
  },
  '&::-webkit-scrollbar-thumb': {
    backgroundColor: 'var(--border)',
    borderRadius: '100px',
  },
  overflow: 'auto',

  // Медиа-запросы идут последними: иначе объявления ниже перебьют их
  // (media query не добавляет специфичности).
  '@media (max-width: 1023px)': {
    width: '70%',
  },
  '@media (max-width: 767px)': {
    width: 'calc(100% - 24px)',
    maxHeight: 'calc(100% - 32px)',
    padding: '20px 16px 16px 16px',
    borderRadius: '16px',
  },
};
